import React, { useEffect } from "react";
import { Modal, Form, Input, Button, Select } from "antd";
import { useAuth } from "../../hooks/useAuth";

const UpdateDocumentModal = ({
  visible,
  document,
  onCancel,
  onOk,
  loading,
}) => {
  const [form] = Form.useForm();
  const { selectedProject } = useAuth();

  const userRole = selectedProject?.role;
  const isOwnerOrManager =
    userRole === "owner" || userRole === "project_manager";

  const isFolder = document?.document_type === 1 || document?.isFolder;

  useEffect(() => {
    if (document && visible) {
      form.setFieldsValue({
        name: document.name,
        allowed_roles: document.allowed_roles || [
          "owner",
          "project_manager",
          "consultant",
          "subcontractor",
          "field",
        ],
      });
    }
  }, [document, visible, form]);

  const handleSubmit = async () => {
    try {
      const values = await form.validateFields();
      onOk(values);
    } catch (error) {
      console.log("Validation Failed:", error);
    }
  };

  const handleCancel = () => {
    if (form.isFieldsTouched()) {
      Modal.confirm({
        title: "Unsaved Changes",
        content: "You have unsaved changes. Are you sure you want to close without saving?",
        okText: "Yes, Close",
        okType: "danger",
        cancelText: "Cancel",
        onOk: () => {
          form.resetFields();
          onCancel();
        },
      });
    } else {
      form.resetFields();
      onCancel();
    }
  };

  const roles = [
    { label: "Project Admin", value: "owner" },
    { label: "Project Manager", value: "project_manager" },
    { label: "Consultant", value: "consultant" },
    { label: "Subcontractor", value: "subcontractor" },
    { label: "Field", value: "field" },
  ];

  return (
    <Modal
      title={isFolder ? "Update Folder" : "Update Document"}
      open={visible}
      onCancel={handleCancel}
      footer={[
        <Button key="cancel" onClick={handleCancel}>
          Cancel
        </Button>,
        <Button
          key="submit"
          type="primary"
          loading={loading}
          onClick={handleSubmit}
        >
          Update
        </Button>,
      ]}
    >
      <Form form={form} layout="vertical">
        <Form.Item
          label="Name"
          name="name"
          rules={[{ required: true, message: "Please input the name!" }]}
        >
          <Input />
        </Form.Item>
        {isOwnerOrManager && (
          <Form.Item
            label="Allowed Roles"
            name="allowed_roles"
            initialValue={[
              "owner",
              "project_manager",
              "consultant",
              "subcontractor",
              "field",
            ]}
          >
            <Select mode="multiple" placeholder="Select roles">
              {roles.map((role) => (
                <Select.Option
                  key={role.value}
                  value={role.value}
                  disabled={["owner", "project_manager"].includes(role.value)}
                >
                  {role.label}
                </Select.Option>
              ))}
            </Select>
          </Form.Item>
        )}
      </Form>
    </Modal>
  );
};

export default UpdateDocumentModal;
